module.exports = __webpack_public_path__ + "fonts/Anjoman-FaNum-CondensedHeavyItalic.45eadb7.eot";